import {
  DIGITAL,
  IKEA_FAMILY_ONLY,
  IKEA_BUSINESS_NETWORK_ONLY,
} from '../../enums';
import { CSSEvent } from '../../types/model';
import { Colors } from '../Card/Badges';
import cssIngka from '@ingka/variables/colours-css';

const getBadges = (event: CSSEvent) => {
  const badges: [string, Colors][] = [];
  const isDigitalEvent = event.location.type === DIGITAL;

  if (event.loyaltyEvent === IKEA_FAMILY_ONLY) {
    badges.push([
      'event.ikeaFamilyOnly',
      {
        background: cssIngka.colourCommercialMessageIkeaFamily,
        text: cssIngka.colourStaticWhite,
      },
    ]);
  }

  if (event.loyaltyEvent === IKEA_BUSINESS_NETWORK_ONLY) {
    badges.push([
      'event.ikeaBusinessNetworkOnly',
      {
        background: cssIngka.colourStaticWhite,
        text: cssIngka.colourStaticBlack,
      },
    ]);
  }

  if (isDigitalEvent) {
    badges.push([
      'event.digitalEvent',
      {
        background: cssIngka.colourStaticIkeaBrandYellow,
        text: cssIngka.colourStaticBlack,
      },
    ]);
  }

  return badges;
};

export default getBadges;
